import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { useSelector } from 'react-redux';
import SelectFromModal from 'admin/views/chat/modules/select-from-modal'
import PhotosetsContainer from 'admin/containers/pages/photosets/list';
import VideosContainer from 'admin/containers/pages/videos/list';
import ConfirmModal from 'common/components/modules/modal-wrapper';
import RecordedStreams from 'admin/containers/pages/live-stream/list'
import StoreContainer from 'admin/containers/pages/store/list'
import StoriesContainer from 'admin/containers/pages/stories/list'
import { useDispatch } from 'react-redux'
import { clearState as clearPhotosetsState } from 'admin/state/modules/photosets/actions'
import { clearState as clearVideostState } from 'admin/state/modules/videos/actions'
import { changeInitedState as clearStoreState } from 'admin/state/modules/store/actions'
import { updateFiltersInsideModalAction as clearLivestreamFilters, updateLivestreamInitedStateAction } from 'admin/state/modules/livestream/actions'
import { manualAbortApiCall } from 'admin/api/AuthApi'
import { screenWidthSelector } from 'admin/state/modules/common/selectors';
import { isEqual } from 'lodash';

const SelectLibrary = ({
   type,
   handleCloseOpenModal,
   onClickAdd,
   selections,
}) => {
   const screenWidth = useSelector(screenWidthSelector)
   const dispatch = useDispatch()
   const [openDiscardModal, setOpenDiscardModal] = useState(false)

   const [selectedContent, setSelectedContent] = useState(selections || [])

   const clearDataInsideModal = () => {
      const clearStateData = { isInited: false, key: '', filters: {} }
      manualAbortApiCall('getPhotosets', 'ABORTED_MANUAL')
      manualAbortApiCall('fetchVideos', 'ABORTED_MANUAL')
      manualAbortApiCall('fetchStoreData', 'ABORTED_MANUAL')
      manualAbortApiCall('fetchRecordedStreams', 'ABORTED_MANUAL')

      setTimeout(() => {
         dispatch(clearVideostState({ ...clearStateData, videosDataInsideModal: {}, filtersInsideModal: {} }))
         dispatch(clearStoreState(false))
         dispatch(updateLivestreamInitedStateAction(false))
         dispatch(clearLivestreamFilters({}))
         dispatch(clearPhotosetsState({ ...clearStateData, photosetsDataInsideModal: {}, filtersInsideModal: {} }))
      }, 300)
   }

   const onCloseOpenModal = (bool) => {
      if(!bool) {
         clearDataInsideModal()
      }
      if(handleCloseOpenModal){
         handleCloseOpenModal()
      }
   }

   const onOpenDiscardModal = (openDiscardModal = false) => {
      if(!openDiscardModal) {
         onCloseOpenModal(false)
      } else {
         setOpenDiscardModal(openDiscardModal)
      }
   }

   const getSelectedIds = () => {
      return selectedContent?.reduce((acc, it) =>  [...acc, it.id], [])
   }

   const onCloseSelectModal = (needCheck = false) => {
      const currentselectionsId = selections?.reduce((acc, it) =>  [...acc, it.id], [])
      if(needCheck && (selectedContent?.length && !isEqual(getSelectedIds(), currentselectionsId))) {
         onOpenDiscardModal(true)
         return
      }

      onCloseOpenModal(false)
   }


   const onChangeSelectedItems = (item) => {
      if(!item) return

      const isThereItemId = selectedContent?.find(it => item?.id === it?.id)
      setSelectedContent(prev => {
         if(!!isThereItemId) {
            // return prev?.filter(it => it.id !== item.id)
            return prev?.filter(it => {
               if(it.id === item.id){
                  return null
               }
               return it
            })
         }
         return [...prev, { id: item.id }]
      })
   }

   return (
      <SelectFromModal
         closeModal={ _ => {
            onCloseSelectModal(true)
         } }
         onClickAdd={ () => {
            onClickAdd(getSelectedIds())
            onCloseOpenModal(false)
         }  }
         isMobile={ screenWidth < 1025 }
         type={ type }
         disabledButton={ !selectedContent?.length }
         showNewStyles
         childClassName='!pt-0'
      >
         {
            'video' === type && (
               <VideosContainer
                  isInsideModal
                  onSelectThisVideo={ (data) => onChangeSelectedItems({ ...data, type: 'video' }, 'video') }
                  isMultipleSelect
                  showNewStyles
                  selections={ getSelectedIds()  }
                  isMultipleAttachments
                  hideUnpublishedContents
               />
            )
         }
         {
            'photoset' === type && (
               <PhotosetsContainer
                  isInsideModal
                  onSelectThisPhotoset={ (data) => onChangeSelectedItems({ ...data, type: 'photoset' }, 'photoset') }
                  isMultipleSelect
                  showNewStyles
                  selections={ getSelectedIds() }
                  isMultipleAttachments
                  hideUnpublishedContents
                  dontAddInsideModalQueryParamOnApi
               />
            )
         }
         {
            'record_stream' === type && (
               <RecordedStreams
                  isInsideModal
                  showNewStyles
                  onSelectThisVideo={ (item) => {
                     onChangeSelectedItems({ ...item, type: 'recorded_streams' }, 'recorded_streams')
                  } }
                  isMultipleSelect
                  selections={ getSelectedIds() }
                  hideUnpublishedContents
                  preventAutoSelect
               />
            )
         }
         {
            'store' === type && (
               <StoreContainer
                  isInsideModal
                  onSelectItem={ (item) => onChangeSelectedItems({ ...item, type: 'store' }, 'store') }
                  selections={ getSelectedIds() }
                  hideUnpublishedContents
               />
            )
         }
         {
            'stories' === type && (
               <StoriesContainer
                  isInsideModal
                  onSelectItem={ (item) => onChangeSelectedItems({ ...item, type: 'stories' }, 'stories') }
                  selections={ getSelectedIds() }
                  hideUnpublishedContents
               />
            )
         }
         {
            !!openDiscardModal &&
               <ConfirmModal
                  type='confirm'
                  icon='cancel'
                  iconColor='error'
                  descriptionColorClass='text-secondary'
                  onCloseModal={ () => {
                     setOpenDiscardModal(false)
                  }  }
                  title='Discard changes?'
                  description='Changes you made so far will not be saved'
                  cancelText='Keep editing'
                  nonPrimaryColor
                  contentWidth='375px'
                  isMobile={ screenWidth < 1025 }
                  iconSize='2xl'
                  buttonText='Discard changes'
                  textColor='error'
                  action={ () => {
                     onOpenDiscardModal(false)
                  } }
                  buttonClassName='mt-8'
                  modalClassName='!z-[100]'
               />
         }
      </SelectFromModal>

   )
}

SelectLibrary.propTypes = {
   type: PropTypes.string,
   handleCloseOpenModal: PropTypes.func,
   onClickAdd: PropTypes.func,
   selections: PropTypes.array,
}

export default SelectLibrary
